// extracted by mini-css-extract-plugin
export var redoItem = "_ix-1";
export var redoTrigger = "_ix-0";